export default (priority) => {
  if (typeof priority !== 'number') return '';
  switch (priority >> 24) { // eslint-disable-line no-bitwise
    case 0: return 'TURN/TLS';
    case 1: return 'TURN/TCP';
    case 2: return 'TURN/UDP';
    default: return '';
  }
};
